import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { useCoilStore } from "shared/coils/stores/coilStore";

export interface DeleteCoilRequest {
  coilId: string;
}

export interface DeleteCoilResponse {
  ok: true;
}

export function useDeleteCoil() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useCoilStore();

  return {
    execute
  };

  async function execute(action: DeleteCoilRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`coil/${action.coilId}`), {
      method: 'DELETE',
      headers,
    });

    const text = translations.value.coils.actions.delete;

    const response = await httpClient.action<DeleteCoilResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      processOk() {
        store.remove(action.coilId);
        return Promise.resolve({
          ok: true
        });
      },
    });

    return response;
  }
}
